export default "__VITE_ASSET__M2bR3G4j__"